import { Component, OnInit, ViewChild } from '@angular/core';
import { first, shareReplay } from 'rxjs';
import { MenuItem, MessageService } from 'primeng/api';
import { JEService } from 'src/app/services/je-services.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { DashboardService } from 'src/app/services/dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { Table } from 'primeng/table';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-tankstagesurvey2',
  templateUrl: './tankstagesurvey2.component.html',
  styleUrls: ['./tankstagesurvey2.component.scss'],
})
export class Tankstagesurvey2Component implements OnInit {
  @ViewChild('tankTable', { static: true })
  public tankTable: Table;
  
  items: any[];
  selectedStatus: any;
  userId: any;
  stage: any;
  public tankData: any;
  canEditPondData: boolean;
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  filteredDataForExport: any = [];
  appVerificationItems: MenuItem[];
  date: any;
  remarks: String;
  public userID: any;
  public ipAddress: any = '000.000.000';

  public loading: boolean = false;
  public subscriptions: any = [];
  public subjectSub:any;
  public selectedYear:any;

  constructor(
    private messageService: MessageService,
    private pondService: JEService,
    private deptDashBoardService: DepartmentDashboardService,
    public router: Router,
    private ipService: IpAddressService,
    private dashboard: DashboardService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService, 
  ) {}

  ngOnInit(): void {
    this.date = new Date();
    if (
      this.router.url.startsWith('/je') ||
      this.router.url.startsWith('/sdo') ||
      this.router.url.startsWith('/xen')
    ) {
      this.canEditPondData = false;
    } else {
      this.canEditPondData = true;
    }
    this.getIP();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    // this.loadData();
    this.loadDataAndApplyFilter();

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(
            this.filteredDataForExport,
            `Filtered Pond Tank Stage-2 Survey Lot Data_(${this.date})`
          );
        },
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.filteredDataForExport, `Filtered Lot Data__(${this.date})`);
      //   }
      // },
    ];
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        this.loadData();
   
        this.selectedYear = res;
        this.tankTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }


  loadData() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    this.stage = 2;
    // this.loader.start();
    this.loading = true;
    let sub = this.pondService
      .GetSubsidyAppForPondVer_SubsidyCalc_Stage2(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.getmasterData();
          // this.activityRecordService.activityRecord(
          //   this.userID,
          //   'Tank Stage-2 Subsidy',
          //   '',
          //   new Date(),
          //   'Success'
          //   );
            
            // console.log('Response Data', data);
            this.tankData = data;
        },
        error: (err) => {
          this.tankData = [];
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(
          //   this.userID,
          //   'Tank Stage-2 Subsidy',
          //   '',
          //   new Date(),
          //   err
          // );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }


  getmasterData() {
    let actionId: number;
    if (
      this.router.url.split('/')[1] == 'department' ||
      this.router.url.split('/')[1] == 'admin' ||
      this.router.url.split('/')[1] == 'ew-department'
    ) {
      actionId = 30;
    } else {
      actionId = 5; // Do not Change, it is fixed for Farmer Application Verifications
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });
  }
  selectFarmerApplication(application) {
    if (application.Scheme_Specific_Id) {
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.Scheme_Specific_Id.toString()) } }));
      window.open(link, '_blank');
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Invalid App ID',
      });
    }
  }

  onHeaderCheckboxToggle(event) {
    this.calculation();
    let length = this.filteredDataForExport.length;
    if (event.checked) {
      this.messageService.add({
        severity: 'info',
        summary: 'Multiple Product Selected',
        detail: `Total ${length} Products Selected`,
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Multiple Product Unselected',
        detail: '',
      });
    }
  }
  calculation() {
    this.filteredData = [];
    this.totalSelectedApp = 0;
    this.totalSubToFarmer = 0;
    this.totalSubToVendor = 0;
    this.totalFarmerRefund = 0;

    this.totalSelectedApp = this.filteredDataForExport.length;
    this.filteredDataForExport.forEach((val) => {
      this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
      this.totalSubToVendor += val.SubsidyToVendor_Amount;
      this.totalFarmerRefund += val.FarmerRefund_Amount;
    });
    this.filteredDataForExport.forEach((val) => {
      this.filteredData.push({
        appID: val.Scheme_Specific_Id,
        programID: val.ProgramID,
        subsidy_Amt: val.ActualSubsidy_Stage2 ? val.ActualSubsidy_Stage2 : 0,
        // amt_Disbus_to_Vendor: 0,
        // amt_Refund_to_Farmer: 0,
        farmerShareToVendor: val.Farmer_Share_To_Vendor,
        state_share_amt: val.State_Share_Payment_Amount,
        centre_share_amt: val.Center_Share_Payment_Amount,
        topUp: val?.TopUp,
        aby: val?.ABY
      });
    });
  }
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Full Name in English': d.Farmer_Name_In_English,
          'Full Name in Recognized Official Language':
            d.Full_Name_in_Recognized_Official_Language,
          'Caste': d.Caste_Description,
          'Gender': d.Gender,
          'Address Line 1': d.Address_Line_1,
          'Address Line 2': d.Address_Line_2,
          'Address Line 3': d.Address_Line_3,
          'District': d.District,
          'State': d.State,
          'Country': d.Country,
          'Bank Name': d.Farmer_Bank_Name,
          'IFSC Code': d.Farmer_IFSCCode,
          'Account Number': d.Farmer_Account_Number
            ? d.Farmer_Account_Number.toString()
            : '',
          'Aadhar Number': d.Aadhar_Number ? d.Aadhar_Number.toString() : '',
          'PinCode': d.Pincode,
          'Scheme Specific Id': d.Scheme_Specific_Id,
          'Center Share Payment Amount': d.Center_Share_Payment_Amount,
          'State Share Payment Amount': d.State_Share_Payment_Amount,
          'ABY': d.ABY,
          'Top Up': d.TopUp,
          'Application Type': d.ApplicantType,
          'User Type': d.UserType,
          'Coverage Area': d.Coverage_Area,
          // 'ActualSubsidy Stage2': d.ActualSubsidy_Stage2
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  handleClick() {
    let newFilteredData = this.filteredData.map((row) => ({
      ...row,
      status: this.selectedStatus.flag,
      remarks: this.remarks ? this.remarks : '',
    }));

    let reqBody = {
      listLotData: newFilteredData,
      userID: this.userID,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
      stage: '2',
      financialyear: '',
    }
    // console.log("reqBody", reqBody)

    this.insertMISubsidyLot(reqBody);
  }

  insertMISubsidyLot(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify([reqBody]))
    }

    this.loader.start();
    this.deptDashBoardService
      .insertpondSubsidyLot(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if(data == "S:Successfully Submitted" || data == "Success"){
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: JSON.stringify(data),
            });
            this.filteredDataForExport = [];
            this.loadData();
            this.calculation();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: JSON.stringify(data),
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
  onRowSelect(event) {
    this.calculation();
    this.messageService.add({
      severity: 'info',
      summary: 'Application Selected',
      detail: event.data.name,
    });
  }

  onRowUnselect(event) {
    this.calculation();
    this.messageService.add({
      severity: 'info',
      summary: 'Application Unselected',
      detail: event.data.name,
    });
  }
}
